(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onScrollRestorationStart = this.onScrollRestorationStart.bind(this);
      this.onScrollRestorationEnd = this.onScrollRestorationEnd.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('rfa:scroll-restoration:start', this.onScrollRestorationStart);
      window.addEventListener('rfa:scroll-restoration:end', this.onScrollRestorationEnd);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('rfa:scroll-restoration:start', this.onScrollRestorationStart);
      window.removeEventListener('rfa:scroll-restoration:end', this.onScrollRestorationEnd);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.isRestoringScrollPosition) return;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    onScrollRestorationStart() {
      this.isRestoringScrollPosition = true;
    }

    onScrollRestorationEnd() {
      this.isRestoringScrollPosition = false;
      this.preventReveal = false;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.currentScrollTop > this.headerBounds.bottom) {
        this.reveal();
      } else {
        this.reset();
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!window.rfaMobileSearchMenuBound) {
    window.rfaMobileSearchMenuBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-rfa-mobile-search-trigger]');
      if (!trigger) return;

      event.preventDefault();
      const header = trigger.closest('.header');
      const mobileSearch = header?.querySelector('.rfa-mobile-search-overlay > details');
      const mobileSearchToggle = mobileSearch?.querySelector('summary');
      const mobileSearchModal = mobileSearch?.closest('details-modal');
      if (!mobileSearch || !mobileSearchToggle || !mobileSearchModal || mobileSearch.open) return;

      trigger.closest('header-drawer')?.closeMenuDrawer?.(event, false);
      mobileSearchModal.open({ target: mobileSearchToggle });
      window.requestAnimationFrame(() => {
        mobileSearch.querySelector('input[type="search"]')?.focus({ preventScroll: true });
      });
    });
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-vollbild"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class RfaHero {
      constructor(root) {
        this.root = root;
        this.images = Array.from(root.querySelectorAll('[data-rfa-hero-image]'));
        this.reviews = Array.from(root.querySelectorAll('.rfa-hero__reviews'));
        this.horizontalAnchors = new WeakMap();
        this.mobileMedia = window.matchMedia('(max-width: 749px)');
        this.handleMobileMediaChange = () => this.positionImages();
        this.handleReviewClick = (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.showNextReview();
        };
        this.timer = null;
        this.index = 0;
        this.reviewIndex = 0;
        this.resizeObserver = new ResizeObserver(() => {
          this.positionImages();
        });
        this.reviewObserver = new MutationObserver(() => {
          this.syncReviewState();
        });
        this.resizeObserver.observe(root);
        this.reviewObserver.observe(root, { childList: true, subtree: true });
        this.mobileMedia.addEventListener('change', this.handleMobileMediaChange);
        this.reviews.forEach((review) => review.addEventListener('click', this.handleReviewClick, true));
        this.positionImages();
        this.syncReviewState();
        this.showReview(this.reviewIndex);
        this.start();
      }

      showReview(index) {
        if (this.reviews.length === 0) return;

        this.reviewIndex = index;
        this.reviews.forEach((review, reviewIndex) => {
          review.classList.toggle('rfa-hero__reviews--active', reviewIndex === index);
        });
      }

      showNextReview() {
        if (this.reviews.length < 2) return;

        this.showReview((this.reviewIndex + 1) % this.reviews.length);
      }

      syncReviewState() {
        this.root.querySelectorAll('.rfa-hero__reviews').forEach((reviews) => {
          const rating = reviews.querySelector('.jdgm-all-reviews-rating');
          const verified = reviews.querySelector('.jdgm-verified-by');
          const hasCompleteRating = rating?.querySelectorAll('.jdgm-star').length > 0;

          reviews.classList.toggle('rfa-hero__reviews--ready', Boolean(hasCompleteRating && verified));
        });
      }

      positionImage(media) {
        const image = media.querySelector('.rfa-hero__img');
        if (!image || !image.naturalWidth || !media.clientWidth || !media.clientHeight) return;

        const zoom = Number.parseFloat(media.dataset.zoom) || 1;
        const useMobilePosition = this.mobileMedia.matches;
        const panX = (Number.parseFloat(useMobilePosition ? media.dataset.mobilePanX : media.dataset.panX) || 0) / 100;
        const panY = (Number.parseFloat(useMobilePosition ? media.dataset.mobilePanY : media.dataset.panY) || 0) / 100;
        const coverScale = Math.max(
          media.clientWidth / image.naturalWidth,
          media.clientHeight / image.naturalHeight
        );
        const width = image.naturalWidth * coverScale * zoom;
        const height = image.naturalHeight * coverScale * zoom;
        const overflowX = Math.max(0, width - media.clientWidth);
        const overflowY = Math.max(0, height - media.clientHeight);
        image.style.width = `${width}px`;
        image.style.height = `${height}px`;
        if (useMobilePosition) {
          image.style.left = `${-overflowX * panX}px`;
          image.style.right = 'auto';
        } else {
          let horizontalAnchor = this.horizontalAnchors.get(media);
          if (!horizontalAnchor) {
            const left = -overflowX * panX;
            horizontalAnchor = {
              left,
              center: left + overflowX / 2,
              right: -overflowX - left
            };
            this.horizontalAnchors.set(media, horizontalAnchor);
          }
          const clampHorizontalOffset = (offset) => Math.min(0, Math.max(-overflowX, offset));
          if (this.root.dataset.resizeAnchor === 'right') {
            image.style.left = 'auto';
            image.style.right = `${clampHorizontalOffset(horizontalAnchor.right)}px`;
          } else if (this.root.dataset.resizeAnchor === 'center') {
            image.style.left = `${clampHorizontalOffset(horizontalAnchor.center - overflowX / 2)}px`;
            image.style.right = 'auto';
          } else {
            image.style.left = `${clampHorizontalOffset(horizontalAnchor.left)}px`;
            image.style.right = 'auto';
          }
        }
        image.style.top = `${-overflowY * panY}px`;
      }

      positionImages() {
        this.images.forEach((media) => {
          const image = media.querySelector('.rfa-hero__img');
          if (!image) return;
          if (image.complete) {
            this.positionImage(media);
          } else {
            image.addEventListener('load', () => this.positionImage(media), { once: true });
          }
        });
      }

      show(index) {
        const previousIndex = this.index;
        this.index = index;
        this.images.forEach((image, imageIndex) => {
          image.classList.toggle('was-active', imageIndex === previousIndex && previousIndex !== index);
          image.classList.toggle('is-active', imageIndex === index);
        });
      }

      start() {
        if (this.images.length === 0) return;
        if (this.images.length === 1) {
          this.show(0);
          return;
        }

        if (this.root.dataset.imageMode === 'random') {
          const key = `rfa-hero-image-${this.root.dataset.sectionId}`;
          let selected = null;

          try {
            selected = Number.parseInt(window.sessionStorage.getItem(key), 10);
          } catch (error) {
            selected = null;
          }

          if (!Number.isInteger(selected) || selected < 0 || selected >= this.images.length) {
            selected = Math.floor(Math.random() * this.images.length);
            try {
              window.sessionStorage.setItem(key, String(selected));
            } catch (error) {
              selected = selected;
            }
          }

          this.show(selected);
          return;
        }

        this.show(0);
        const delay = Number.parseInt(this.root.dataset.cycleDelay, 10) || 6000;
        this.timer = window.setInterval(() => {
          this.show((this.index + 1) % this.images.length);
        }, delay);
      }

      destroy() {
        if (this.timer) window.clearInterval(this.timer);
        this.resizeObserver.disconnect();
        this.reviewObserver.disconnect();
        this.mobileMedia.removeEventListener('change', this.handleMobileMediaChange);
        this.reviews.forEach((review) => review.removeEventListener('click', this.handleReviewClick, true));
      }
    }

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-rfa-hero]').forEach((root) => {
        if (root.rfaHero) root.rfaHero.destroy();
        root.rfaHero = new RfaHero(root);
      });
    };

    initialize();

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector('[data-rfa-hero]');
      if (root && root.rfaHero) root.rfaHero.destroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfa-customer-review"]) return;
  try {
    
  class RfaCustomerReviewWidget extends HTMLElement {
    connectedCallback() {
      this.formObserver = new MutationObserver(() => this.prepareStoreReviewForm());
      this.formObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      this.prepareStoreReviewForm();
    }

    disconnectedCallback() {
      this.formObserver?.disconnect();
      this.submissionObserver?.disconnect();
    }

    prepareStoreReviewForm() {
      const writeReviewButton = this.querySelector('.jdgm-write-rev-link');
      const formWrapper = this.querySelector('.jdgm-form-wrapper');
      const form = formWrapper?.querySelector('.jdgm-form');

      if (writeReviewButton?.getAttribute('href') === '#') {
        writeReviewButton.setAttribute('href', `${window.location.pathname}${window.location.search}`);
      }

      if (this.hasCompletedReviewSubmission(formWrapper, form)) {
        this.renderReviewSubmissionSuccess(formWrapper);
        return;
      }

      if (!form || !formWrapper || formWrapper.offsetParent === null) return;

      this.classList.add('rfa-customer-review__widget--form-ready');

      if (this.refineFormFields(form)) {
        this.dataset.reviewFormReady = 'true';
        this.installSubmissionTracking(form);
        this.formObserver?.disconnect();
      }
    }

    installSubmissionTracking(form) {
      if (form.dataset.rfaReviewSubmissionTracking === 'true') return;

      form.dataset.rfaReviewSubmissionTracking = 'true';
      form.addEventListener('submit', () => this.beginReviewSubmissionTracking(), { capture: true });
    }

    beginReviewSubmissionTracking() {
      if (this.reviewSubmissionPending) return;

      this.reviewSubmissionPending = true;
      this.submissionObserver = new MutationObserver(() => {
        const formWrapper = this.querySelector('.jdgm-form-wrapper');
        const form = formWrapper?.querySelector('.jdgm-form');

        if (this.hasCompletedReviewSubmission(formWrapper, form)) {
          this.renderReviewSubmissionSuccess(formWrapper);
        }
      });
      this.submissionObserver.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    hasCompletedReviewSubmission(formWrapper, form) {
      if (!this.reviewSubmissionPending || this.dataset.reviewSubmissionComplete === 'true') return false;

      if (!form || form.offsetParent === null) return true;

      return Boolean(this.querySelector(':is(.jdgm-form__success, .jdgm-form__success-message, .jdgm-success-message, .jdgm-thank-you, .jdgm-notification, [data-status="success"])'));
    }

    renderReviewSubmissionSuccess(formWrapper) {
      const successTemplate = this.querySelector('template[data-rfa-review-success]');

      if (!formWrapper || !successTemplate || this.dataset.reviewSubmissionComplete === 'true') return;

      formWrapper.replaceChildren(successTemplate.content.cloneNode(true));
      this.dataset.reviewSubmissionComplete = 'true';
      this.formObserver?.disconnect();
      this.submissionObserver?.disconnect();
      formWrapper.querySelector('.rfa-customer-review__success')?.focus({ preventScroll: true });
    }

    refineFormFields(form) {
      const mediaFieldset = form?.querySelector('.jdgm-media-fieldset__container')?.closest('.jdgm-form__fieldset');
      const mediaLabel = mediaFieldset?.querySelector('label');
      const nameFormat = form?.querySelector('.jdgm-form__reviewer-name-format-container');
      const nameFormatLabel = nameFormat?.querySelector('.jdgm-form__inline-label');
      const mediaIcon = form?.querySelector('.jdgm-media-fieldset__icon');
      const uploadIcon = this.querySelector('template[data-rfa-review-upload-icon]');

      if (mediaLabel) {
        mediaLabel.textContent = 'Bild (optional)';
      }

      if (nameFormatLabel) {
        nameFormatLabel.textContent = 'wird öffentlich angezeigt';
      }

      if (mediaIcon && uploadIcon && !mediaIcon.querySelector('.rfa-customer-review__upload-icon')) {
        mediaIcon.append(uploadIcon.content.cloneNode(true));
      }

      return this.installRatingCount(form);
    }

    installRatingCount(form) {
      const rating = form.querySelector('.jdgm-form__rating');

      if (!rating) return false;

      if (rating.querySelector('.rfa-customer-review__rating-count')) return true;

      const count = document.createElement('output');
      count.className = 'rfa-customer-review__rating-count';
      count.setAttribute('aria-live', 'polite');
      rating.append(count);

      const updateSelectedRating = () => {
        const selectedInput = rating.querySelector("input[type='radio']:checked");
        const selectedStar = rating.querySelector("[role='radio'][aria-checked='true']");
        this.setRatingCount(count, selectedInput?.value || selectedStar?.dataset.alt);
      };

      const updateHoveredRating = (target) => {
        const value = this.ratingValueFromTarget(target, rating);

        if (value) this.setRatingCount(count, value);
      };

      rating.addEventListener('pointerover', (event) => updateHoveredRating(event.target));
      rating.addEventListener('focusin', (event) => updateHoveredRating(event.target));
      rating.addEventListener('change', updateSelectedRating);
      rating.addEventListener('click', () => window.requestAnimationFrame(updateSelectedRating));
      rating.addEventListener('pointerout', (event) => {
        if (!rating.contains(event.relatedTarget)) updateSelectedRating();
      });
      rating.addEventListener('focusout', (event) => {
        if (!rating.contains(event.relatedTarget)) updateSelectedRating();
      });

      updateSelectedRating();
      return true;
    }

    ratingValueFromTarget(target, rating) {
      const radioInputs = Array.from(rating.querySelectorAll("input[type='radio']"));
      const input = target.closest("input[type='radio']");
      const label = target.closest('label');
      const labelledInput = label?.htmlFor
        ? radioInputs.find((radio) => radio.id === label.htmlFor)
        : label?.querySelector("input[type='radio']");
      const valueElement = target.closest('[data-alt], [data-score], [data-rating], [data-value]');
      const value = input?.value || labelledInput?.value || valueElement?.dataset.alt || valueElement?.dataset.score || valueElement?.dataset.rating || valueElement?.dataset.value;

      return value;
    }

    setRatingCount(count, value) {
      const numericValue = Number.parseInt(value, 10);
      const rating = Number.isInteger(numericValue) && numericValue >= 1 && numericValue <= 5 ? numericValue : 0;

      count.value = `${rating}/5`;
      count.textContent = count.value;
    }
  }

  if (!customElements.get('rfa-customer-review-widget')) {
    customElements.define('rfa-customer-review-widget', RfaCustomerReviewWidget);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werke-kollektion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-rf-works]';

    function artworkRatio(card) {
      return Number.parseFloat(card.style.getPropertyValue('--rf-art-ratio')) || 1;
    }

    function horizontalMatPadding(card) {
      const mat = card.querySelector('.rf-card__mat');
      if (!mat) return 0;
      const styles = window.getComputedStyle(mat);
      return (Number.parseFloat(styles.paddingLeft) || 0) + (Number.parseFloat(styles.paddingRight) || 0);
    }

    function groupCards(cards, columns) {
      return cards.reduce((rows, card, index) => {
        const rowIndex = Math.floor(index / columns);
        if (!rows[rowIndex]) rows[rowIndex] = [];
        rows[rowIndex].push(card);
        return rows;
      }, []);
    }

    function sharedArtworkHeight(rows, grid) {
      const row = grid.querySelector('.rf-grid__row');
      const gap = row ? Number.parseFloat(window.getComputedStyle(row).columnGap) || 0 : 0;
      return Math.min(...rows.map((rowCards) => {
        const ratios = rowCards.reduce((total, card) => total + artworkRatio(card), 0);
        const padding = rowCards.reduce((total, card) => total + horizontalMatPadding(card), 0);
        return (grid.clientWidth - gap * (rowCards.length - 1) - padding) / ratios;
      }));
    }

    function responsiveColumns(grid, cards) {
      if (window.matchMedia('(max-width: 749px)').matches) return 1;

      const maximum = Math.min(Number.parseInt(grid.dataset.maxColumns, 10) || 1, cards.length);
      const minimumWidths = [0, 0, 750, 950, 1150, 1350, 1550];
      let columns = 1;
      for (let candidate = 2; candidate <= maximum; candidate += 1) {
        if (grid.clientWidth >= minimumWidths[candidate]) columns = candidate;
      }
      return columns;
    }

    function rebuildRows(grid, cards, columns) {
      if (grid.dataset.activeColumns === String(columns)) return;

      const fragment = document.createDocumentFragment();
      groupCards(cards, columns).forEach((rowCards) => {
        const row = document.createElement('div');
        row.className = 'rf-grid__row';
        rowCards.forEach((card) => row.append(card));
        fragment.append(row);
      });
      grid.replaceChildren(fragment);
      grid.dataset.activeColumns = String(columns);
    }

    function layoutCards(grid) {
      const cards = Array.from(grid.querySelectorAll('.rf-card'));
      if (!cards.length || !grid.clientWidth) return;

      const columns = responsiveColumns(grid, cards);
      rebuildRows(grid, cards, columns);

      if (columns === 1) {
        cards.forEach((card) => {
          card.style.flexBasis = '100%';
        });
        return;
      }

      const rows = Array.from(grid.querySelectorAll(':scope > .rf-grid__row'))
        .map((row) => Array.from(row.querySelectorAll(':scope > .rf-card')))
        .filter((rowCards) => rowCards.length);
      const artworkHeight = sharedArtworkHeight(rows, grid);

      rows.forEach((rowCards) => {
        rowCards.forEach((card) => {
          const cardWidth = artworkHeight * artworkRatio(card) + horizontalMatPadding(card);
          card.style.flexBasis = `${cardWidth}px`;
        });
      });
    }

    function preloadMobileImages(section) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const images = Array.from(section.querySelectorAll('img.rf-art[loading="lazy"]'));
      if (!images.length) return;

      if (!('IntersectionObserver' in window)) {
        images.forEach((image) => {
          image.loading = 'eager';
        });
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.loading = 'eager';
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: `${Math.round(window.innerHeight * 0.75)}px 0px`,
        threshold: 0.01,
      });

      images.forEach((image) => observer.observe(image));
    }

    function initSection(section) {
      if (!section || section.dataset.rfInitialized === 'true') return;
      section.dataset.rfInitialized = 'true';

      preloadMobileImages(section);

      const grid = section.querySelector('.rf-grid');
      if (grid) {
        const updateLayout = () => layoutCards(grid);
        updateLayout();
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(updateLayout);
          observer.observe(grid);
        } else {
          window.addEventListener('resize', updateLayout);
        }
      }

      section.querySelectorAll('.rf-product-form').forEach((form) => {
        form.addEventListener('submit', () => {
          const button = form.querySelector('.rf-add');
          const label = button && button.querySelector('span');
          if (!button || !label || button.disabled) return;
          const previousLabel = label.textContent;
          window.setTimeout(() => {
            if (!button.classList.contains('loading')) label.textContent = section.dataset.addedLabel;
          }, 80);
          window.setTimeout(() => {
            label.textContent = previousLabel;
          }, 1480);
        });
      });

    }

    function initAll(root = document) {
      if (root.matches && root.matches(sectionSelector)) initSection(root);
      root.querySelectorAll(sectionSelector).forEach(initSection);
    }

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
